import { useT } from '@hooks';
import React from 'react';
import { appStore } from 'store';
import TimerV2 from '../timerV2';

import s from './index.module.scss';

function DiscountBlockV2() {
	const { T } = useT();
	const { paymentStore } = appStore;

	function showPaymentModal() {
		paymentStore.setPaymentModalVisible(true);
	}

	return (
		<div className={s.discountBlockV2}>
			<div className={s.discountBlockV2_block}>
				<div className={s.discountBlockV2_timerBlock}>
					<p className={s.discountBlockV2_text}>{T('discount_block_1')}</p>
					<div className={s.discountBlockV2_timer}>
						<TimerV2 />
					</div>
				</div>
				<div className={s.discountBlockV2_button} onClick={showPaymentModal}>
					{T('get_my_plan_2')}
				</div>
			</div>
		</div>
	);
}

export default DiscountBlockV2;
